import { useContext, useEffect, useState } from 'react';

import * as intl from 'react-intl-universal';
import { Button, Col, Row } from 'reactstrap';

import AppContext from 'context/AppContext';
import UserProfileTab from 'shared/enums/UserProfileTab';

import styles from './headerBanner.module.scss';
import HeaderBannerProps from './HeaderBannerProps';

const HeaderBanner: React.FC<HeaderBannerProps> = (
  props: HeaderBannerProps
) => {
  const { onAction } = props;

  const appContext = useContext(AppContext);
  const { hasActivatedMFA, userProfileTab, setUserProfileTab } = appContext;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleActivate = (): void => {
    setUserProfileTab(UserProfileTab.MFA_SECURITY);
    onAction();
  };

  useEffect(() => {
    setIsOpen(
      userProfileTab !== UserProfileTab.MFA_SECURITY && !hasActivatedMFA
    );
  }, [hasActivatedMFA, userProfileTab]);

  return (
    <>
      {isOpen && (
        <div
          className={`${styles.headerBanner} px-4 d-flex justify-content-between align-items-center`}
        >
          <div className="d-flex align-items-center gap-2">
            <i
              className={`icon-attention text-secondary ${styles.bannerIcon}`}
            />
            <span className={`text-12-medium ${styles.display_text} px-2`}>
              {intl.get('LBL_MFA_ACTIVATE_REMINDER')}
            </span>
          </div>

          <Row className="align-items-center g-2 flex-nowrap">
            <Col xs="auto">
              <Button color="primary" size="sm" onClick={handleActivate}>
                {intl.get('BTN_ACTIVATE')}
              </Button>
            </Col>
            <Col xs="auto" className="px-0">
              <Button
                className="btn-link p-0 text-center"
                onClick={() => setIsOpen(false)}
                size="sm"
              >
                <i className={`icon-close ${styles.smallIcon}`} />
              </Button>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default HeaderBanner;
